export default "__VITE_ASSET__21e8094f__"